module.exports = "<a href=\"#\"><i class=\"fas fa-shopping-cart\"></i></a>"